<template>
  <div class="attachments">
    <h1 class="heading-sm heading text-center">Attachments</h1>
    <file-picker
      :label="attachment.label"
      :position_color="position_color"
      @input="upload"
      v-model="attachments[index].file"
      v-for="(attachment, index) in attachments"
      :key="index"
      :error-class="errorClass"
    ></file-picker>
  </div>
</template>

<script>
import BasicButton from "../BasicButton";
import FilePicker from "./FilePicker";

export default {
  components: {
    BasicButton,
    FilePicker
  },
  name: "Attachments",
  props: {
    errorClass: Object,
    value: {
      type: Array
    },
    position_color: {
      default: 0
    }
  },
  data() {
    return {
      attachments: []
    };
  },
  created() {
    this.attachments = this.value;
  },
  methods: {
    upload() {
      this.$emit("input", this.attachments);
    }
  },
  watch: {
    value() {
      this.attachments = this.value;
    }
  }
};
</script>

<style scoped lang="scss" type="text/scss">
@import "../../assets/scss/globals";

.attachment--text {
  color: gray;
  font-size: 14px;
}

.attach-button {
  background-color: black; /* Green */
  border: none;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
}

.file__label {
  width: 264px;
  height: 33px;
  background-color: $mine-shaft;
}
</style>



// WEBPACK FOOTER //
// src/components/applicationPageComponents/Attachments.vue